module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent_2/work/861f9e7e0cb825c7/node_modules/core-js/modules/_is-object.js
// module id = JXkd
// module chunks = 15